<div class="row">
  <div class="col col-lg-7">
    <div
      *ngIf="cancellationPeriod"
      class="d-flex flex-row justify-content-between py-3"
    >
      <div class="w-50">
        <span class="fw-bold">{{ 'surcharges.cancellationPeriod' | translate }}</span>
      </div>
      <div class="w-50">{{ cancellationPeriod }} {{ 'dateTime.hourUnit' | translate }}</div>
    </div>
    <h3 class="headline-24 mt-4">{{ 'surcharges.plural' | translate }}</h3>
    <base-surcharges
      *ngIf="surcharges"
      [surcharges]="surcharges"
      [hideHeaders]="true"
    ></base-surcharges>
  </div>
</div>
